namespace appn.views.docDefinitions.edit {

    export function init(): void {
        addEvents();
        appn.folderFilter.initLinkedFolders();

        if ($('nav .navbar-nav-right button[value*="Trash"]').length > 0)
            appn.trash.addTrashMessage($('nav .navbar-nav-right button[value*="Trash"]'), '#DocDefinition_Name', 'DocDefinition_VersionNo', 'DocDefinition_Status');
    }

    function addEvents() {
        // Hook save link
        $('#saveLink').on('click', function() {
            $('form#appnForm').submit();
        });
    }
}
